/**
 * 三级路由 相关菜单配置
 *
 */

// import Layout from "../components/layout";
import { lazyLoad } from "@/utils/lazyLoad";
const defaultRoutes = [
  {
    // component: Layout,
    component: lazyLoad,
    path: "",
    name: "DefaultRoutes",
    hidden: true,
    children: [
      {
        path: "/template/detail",
        name: "TemplatesDetail",
        component: () => import("../pages/templates/list/detail.vue"),
        meta: {
          title: "模版详情",
          parentName: "TemplatesList",
        },
      },
      {
        path: "/meeting/list/detail",
        name: "CreateMeeting",
        component: () => import("../pages/meeting/list/detail.vue"),
        meta: {
          title: "创建直播",
          parentName: "MeetingList",
        },
      },
      {
        path: "/meeting/apply/detail",
        name: "editMeetingApply",
        component: () => import("../pages/meeting/apply/detail.vue"),
        meta: {
          title: "编辑申请",
          parentName: "MeetingApply",
        },
      },
      {
        path: "/meeting/apply/detailPreview",
        name: "PreviewMeetingApply",
        component: () => import("../pages/meeting/apply/detailPreview.vue"),
        meta: {
          title: "查看会议",
          parentName: "MeetingApply",
        },
      },
      // {
      //   path: "/operations/doctor/uploadQualification",
      //   name: "UploadQualification",
      //   component: () =>
      //     import("../pages/operations/doctorWhitelist/uploadQualification.vue"),
      //   meta: {
      //     title: "上传资质",
      //     parentName: "DoctorWhitelist",
      //   },
      // },
      {
        path: "/outbound/taskpool/detail",
        name: "TaskPoolDetail",
        component: () => import("../pages/vrManage/taskPool/detail.vue"),
        meta: {
          title: "任务池详情分配",
          parentName: "TaskPool",
        },
      },
      {
        path: "/outbound/vrTask/detail",
        name: "VrTaskDetail",
        component: () => import("../pages/vrManage/vrTask/detail.vue"),
        hidden: true,
        meta: {
          title: "外呼任务查看",
          parentName: "VrTask",
          keepAlive: true,
        },
      },
      {
        path: "/outbound/vrTask/detail/call",
        name: "VrTaskDetailCall",
        component: () => import("../pages/vrManage/vrTask/call/index.vue"),
        hidden: true,
        meta: {
          title: "医生触达/调研详情",
          parentName: "VrTask",
        },
      },
      {
        path: "/outbound/verbalTrick/researchWord",
        name: "ResearchWord",
        component: () =>
          import("../pages/vrManage/verbalTrick/detail/research.vue"),
        hidden: true,
        meta: {
          title: "话术配置详情-调研",
          parentName: "VerbalTrick",
        },
      },
      {
        path: "/outbound/verbalTrick/touchWord",
        name: "TouchWord",
        component: () =>
          import("../pages/vrManage/verbalTrick/detail/touch.vue"),
        meta: {
          title: "话术配置详情-医生触达",
          parentName: "VerbalTrick",
        },
      },
      {
        path: "/operations/patientApproval/record",
        name: "patientApprovalRecord",
        component: () =>
          import("../pages/operations/patientApproval/record.vue"),
        meta: {
          title: "审核记录",
          parentName: "PatientApproval",
        },
      },
      {
        path: "/operations/patientApproval/approval",
        name: "Approval",
        component: () =>
          import("../pages/operations/patientApproval/approval.vue"),
        meta: {
          title: "审核记录",
          parentName: "PatientApproval",
        },
      },
      {
        path: "/operations/patientManage/record",
        name: "PatientListRecord",
        component: () => import("../pages/operations/patientManage/record.vue"),
        meta: {
          title: "修改记录",
          parentName: "PatientList",
        },
      },
      {
        path: "/operations/patientList/patientDetail",
        name: "patientDetail",
        component: () => import("../pages/operations/patientList/patientDetail.vue"),
        meta: {
          title: "患者详情",
          parentName: "PatientCheckList",
        },
      },
      {
        path: "/follow/record/detail",
        name: "followDetail",
        component: () =>import("../pages/dataManage/followRecord/followDetail.vue"),
        meta: {
          title: "随访详情",
          parentName: "FollowRecord",
        },
      },
      {
        path: "/workOrder/List/detail",
        name: "workOrderDetail",
        component: () =>import("../pages/workOrderManage/workOrderDetail.vue"),
        meta: {
          title: "工单详情",
          parentName: "workOrderList",
        },
      },
    ],
  },
];
export default defaultRoutes;
